import { types, async } from '~/utils/typeCreator'

export default types(
  [...async('LOAD_MY_RELATED_NOTICES'), 'CLEAR_STATE'],
  'HOME'
)
